import { useEffect, useState } from 'react';
import './Style.css';
import { NiveisAcesso } from '../../constants/niveisAcesso';
import api from '../../services/api';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Collapse } from 'react-bootstrap';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HealingIcon from '@mui/icons-material/Healing';
import BusinessIcon from '@mui/icons-material/Business';
import ArticleIcon from '@mui/icons-material/Article';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AddLinkIcon from '@mui/icons-material/AddLink';
import SettingsIcon from '@mui/icons-material/Settings';
import PaymentsIcon from '@mui/icons-material/Payments';
import BadgeIcon from '@mui/icons-material/Badge';
import RestorePageIcon from '@mui/icons-material/RestorePage';
import PaidIcon from '@mui/icons-material/Paid';
import PercentIcon from '@mui/icons-material/Percent';
import HailIcon from '@mui/icons-material/Hail';
import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';
import CrisisAlertOutlinedIcon from '@mui/icons-material/CrisisAlertOutlined';
import AddToQueueOutlinedIcon from '@mui/icons-material/AddToQueueOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import AddchartOutlinedIcon from '@mui/icons-material/AddchartOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AssignmentIndSharpIcon from '@mui/icons-material/AssignmentIndSharp';

export const Menu = ({ route }: any) => {
    const [nivelAcesso, setNivelAcesso] = useState(0);
    const [showConfigMenu, setShowConfigMenu] = useState(false);
    const [showVinculosMenu, setShowVinculosMenu] = useState(false);
    const [showAsoMenu, setShowAsoMenu] = useState(false);
    const [showPerfilMenu, setShowPerfilMenu] = useState(false);
    const [showReaproveitamentoMenu, setShowReaproveitamentoMenu] = useState(false)
    const [showFuncionariosMenu, setShowFuncionariosMenu] = useState(false)
    const [showResponsiblesSubMenu, setShowResponsiblesSubMenu] = useState(false);
    const [showAccreditedSubMenu, setShowAccreditedSubMenu] = useState(false);
    const [notificacaoNaoVisualizadaDocumento, setNotificacaoNaoVisualizada] = useState(0);
    const [notificacaoNaoVisualizadaExame, setNotificacaoNaoVisualizadaExame] = useState(0)
    const [mostrarNotificacao, setMostrarNotificacao] = useState(false);
    const [userId, setUserId] = useState(0);
    const [showReaproveitamentoSubMenu, setShowReaproveitamentoSubMenu] = useState(false)

    const [showPagamentosSubMenu, setShowPagamentosSubMenu] = useState(false);

    const toggleReaproveitamentoSubMenu = () => {
        setShowReaproveitamentoSubMenu(prevState => !prevState)
    }

    const togglePagamentosSubMenu = () => {
        setShowPagamentosSubMenu(prevState => !prevState);
    }

    const toggleResponsiblesSubMenu = () => {
        setShowResponsiblesSubMenu(prevState => !prevState);
    };

    const toggleAccreditedSubMenu = () => {
        setShowAccreditedSubMenu(prevState => !prevState);
    };

    const getColorForUserType = (userType: number) => {

        if (userType === 4) {
            return 'rgba(220, 53, 69, 1)';
        } else if (userType === 1 || userType === 2) {
            return 'rgba(25, 135, 84, 1)';
        } else if (userType === 5) {
            return 'rgba(255, 165, 0, 1)';
        }
    }

    const fetchData = async () => {
        try {
            // Retorna usuário logado
            const { data: user } = await api.get('dados-usuario');
            if (user.nome === "Administrador") {
                setUserId(1);
                setNivelAcesso(4);
            } else {
                setUserId(user.id);
                const nivelAcesso = await api.get('nivel-acesso');
                setNivelAcesso(nivelAcesso.data.nivel);
            }
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchNotificacoesDocumento = async () => {
        try {
            const responseNotificacoes = await api.get(`fetch-notificacoes/${userId}/${nivelAcesso}`);
            if (responseNotificacoes.status === 200 && responseNotificacoes.data > 0) {
                setNotificacaoNaoVisualizada(responseNotificacoes.data);
                setMostrarNotificacao(true);
            }
        } catch (error) {
            console.error('Erro ao buscar notificações:', error);
        }
    };

    const fetchNotificacoesExames = async () => {
        try {
            const responseNotificacoes = await api.get(`fetch-notificacoes-reaproveitamento`);
            if (responseNotificacoes.status === 200 && responseNotificacoes.data > 0) {
                setNotificacaoNaoVisualizadaExame(responseNotificacoes.data);
                setMostrarNotificacao(true);
            }
        } catch (error) {
            console.error('Erro ao buscar notificações:', error);
        }
    };

    useEffect(() => {
        if (nivelAcesso !== 0) {
            fetchNotificacoesDocumento();
        }
        if (nivelAcesso === 4) {
            fetchNotificacoesExames();
        }
    }, [nivelAcesso]);

    const handleLinkClick = () => {
        setMostrarNotificacao(false);
        setNotificacaoNaoVisualizada(0);
    };

    const toggleConfigMenu = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowConfigMenu(prevShow => !prevShow);
    };

    const toggleVinculosMenu = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowVinculosMenu(prevShow => !prevShow);
    };

    const togglePerfilMenu = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowPerfilMenu(prevShow => !prevShow);
    };

    const toggleReaproveitamentoMenu = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowReaproveitamentoMenu(prevShow => !prevShow);
    };

    const toggleFuncionariosMenu = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowFuncionariosMenu(prevShow => !prevShow);
    };

    const toggleAsoMenu = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setShowAsoMenu(prevShow => !prevShow);
    };

    const backgroundColor = getColorForUserType(nivelAcesso);

    return (
        <div className="links-menu">
            {nivelAcesso === NiveisAcesso.CLIENTE && (
                <>
                    <a href={`${route}pgr`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><HealthAndSafetyIcon />PGR</span>
                        </div>
                    </a>
                    <a href={`${route}pcmso`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><HealingIcon />PCMSO</span>
                        </div>
                    </a>
                    <div className="link-wrapper">
                        <div className="link" onClick={toggleReaproveitamentoMenu}>
                            <span className='icons-gap'><RestorePageIcon />Reaproveitamento de ASO</span>
                            <span className={`arrow ${showReaproveitamentoMenu ? 'down' : 'right'}`}><ArrowForwardIosIcon style={{ fontSize: '14px' }} /></span>
                        </div>
                        {showReaproveitamentoMenu && (
                            <>
                                <div className="arrow-up"></div>
                                <div className="config-menu">
                                    <div className='config-menu-alinhamento'>
                                        <a href={`${route}reaproveitamento-aso/cadastrar`} className="dropdown-link">
                                            <span className="icons-gap"><AddBoxIcon />Realizar Reaproveitamento</span>
                                        </a>
                                        <a href={`${route}reaproveitamento-aso`} className="dropdown-link">
                                            <span className="icons-gap"><AssignmentIndSharpIcon />ASOS Gerados</span>
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="link-wrapper">
                        <div className="link" onClick={toggleFuncionariosMenu}>
                            <span className='icons-gap'><EngineeringIcon />Funcionários</span>
                            <span className={`arrow ${showFuncionariosMenu ? 'down' : 'right'}`}><ArrowForwardIosIcon style={{ fontSize: '14px' }} /></span>
                        </div>
                        {showFuncionariosMenu && (
                            <>
                                <div className="arrow-up"></div>
                                <div className="config-menu">
                                    <div className='config-menu-alinhamento'>
                                        <a href={`${route}funcionarios`} className="dropdown-link">
                                            <span className="icons-gap"><AddBoxIcon />Minha empresa</span>
                                        </a>
                                        <a href={`${route}trabalhadores`} className="dropdown-link">
                                            <span className="icons-gap"><AssignmentIndSharpIcon />Geral</span>
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <a href={`${route}documentos`} className="link-wrapper" style={{ position: 'relative' }} onClick={handleLinkClick}>
                        <div className="link">
                            <span className='icons-gap'><ArticleIcon />Documentos</span>
                        </div>
                        {notificacaoNaoVisualizadaDocumento > 0 && (
                            <div className='notification-badge-alert' style={{ backgroundColor }}>{notificacaoNaoVisualizadaDocumento}</div>
                        )}
                    </a>
                    <div className="link-wrapper">
                        <div className="link" onClick={togglePerfilMenu}>
                            <span className='icons-gap'><SettingsIcon />Meu Perfil</span>
                            <span className={`arrow ${showPerfilMenu ? 'down' : 'right'}`}><ArrowForwardIosIcon style={{ fontSize: '14px' }} /></span>
                        </div>
                        {showPerfilMenu && (
                            <>
                                <div className="arrow-up"></div>
                                <div className="config-menu">
                                    <div className='config-menu-alinhamento'>
                                        <a href={`${route}pagamentos`} className="dropdown-link">
                                            <span className="icons-gap"><PaymentsIcon />Pagamentos</span>
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </>
            )}

            {nivelAcesso === NiveisAcesso.CREDENCIADO && (
                <>
                    <a href={`${route}vendas-credenciado`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><PaidIcon />Vendas</span>
                        </div>
                    </a>
                    <a href={`${route}comissoes-credenciado`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><PercentIcon />Comissões</span>
                        </div>
                    </a>
                    <a href={`${route}representantes`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><HailIcon />Representantes Comerciais</span>
                        </div>
                    </a>
                </>
            )}

            {nivelAcesso === NiveisAcesso.ADMIN && (
                <>
                    <a href={`${route}pgr`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><HealthAndSafetyIcon />PGR</span>
                        </div>
                    </a>
                    <a href={`${route}pcmso`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><HealingIcon />PCMSO</span>
                        </div>
                    </a>
                    <a href={`${route}empresas`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><BusinessIcon />Empresas</span>
                        </div>
                    </a>
                    <a href={`${route}documentos`} className="link-wrapper" style={{ position: 'relative' }} onClick={handleLinkClick}>
                        <div className="link">
                            <span className='icons-gap'><ArticleIcon />Documentos</span>
                        </div>
                        {notificacaoNaoVisualizadaDocumento > 0 && mostrarNotificacao && (
                            <div className='notification-badge-alert' style={{ backgroundColor }}>{notificacaoNaoVisualizadaDocumento}</div>
                        )}
                    </a>
                    <div className="link-wrapper">
                        <div className="link" onClick={toggleAsoMenu}>
                            <span className='icons-gap'><LocalHospitalIcon />ASO</span>
                            <span className={`arrow ${showAsoMenu ? 'down' : 'right'}`}><ArrowForwardIosIcon style={{ fontSize: '14px' }} /></span>
                        </div>
                        {notificacaoNaoVisualizadaExame > 0 && mostrarNotificacao && (
                            <div className='notification-badge-alert' style={{ backgroundColor }}>{notificacaoNaoVisualizadaExame}</div>
                        )}
                        {showAsoMenu && (
                            <>
                                <div className="arrow-up"></div>
                                <div className="config-menu">
                                    <div className='config-menu-alinhamento'>
                                        <a href={`${route}reaproveitamentos`} className="dropdown-link"
                                            style={{ position: 'relative' }}>
                                            <span className='icons-gap'><RestorePageOutlinedIcon />Reaproveitamentos</span>
                                            {notificacaoNaoVisualizadaExame > 0 && mostrarNotificacao && (
                                                <div className='notification-badge-alert' style={{ backgroundColor }}>{notificacaoNaoVisualizadaExame}</div>
                                            )}
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="link-wrapper">
                        <div className="link" onClick={toggleVinculosMenu}>
                            <span className='icons-gap'><AddLinkIcon />Vínculos</span>
                            <span className={`arrow ${showVinculosMenu ? 'down' : 'right'}`}><ArrowForwardIosIcon style={{ fontSize: '14px' }} /></span>
                        </div>
                        {showVinculosMenu && (
                            <>
                                <div className="arrow-up"></div>
                                <div className="config-menu">
                                    <div className='config-menu-alinhamento'>
                                        <a href={`${route}vincular-riscos`} className="dropdown-link">
                                            <span className='icons-gap'><AddToQueueOutlinedIcon />Vincular Riscos</span>
                                        </a>
                                        <a href={`${route}vincular-exames`} className="dropdown-link">
                                            <span className='icons-gap'><NoteAddOutlinedIcon />Vincular Exames</span></a>
                                        <a href={`${route}vincular-tabelas`} className="dropdown-link">
                                            <span className='icons-gap'><AddchartOutlinedIcon />Vincular Tabelas</span></a>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="link-wrapper">
                        <div className="link" onClick={toggleConfigMenu}>
                            <span className='icons-gap'>
                                <SettingsIcon />Configurações
                            </span>
                            <span className={`arrow ${showConfigMenu ? 'down' : 'right'}`}><ArrowForwardIosIcon style={{ fontSize: '14px' }} /></span>
                        </div>
                        {showConfigMenu && (
                            <>
                                <div className="arrow-up"></div>
                                <div className="config-menu">
                                    <div className='config-menu-alinhamento'>
                                        <a href={`${route}cronograma`} className="dropdown-link">
                                            <span className="icons-gap"><FormatListBulletedOutlinedIcon />Cronograma</span>
                                        </a>
                                        <a href={`${route}produtos`} className="dropdown-link">
                                            <span className="icons-gap"><SellOutlinedIcon />Produtos</span>
                                        </a>
                                        <a href={`${route}cupons`} className="dropdown-link">
                                            <span className="icons-gap"><CardGiftcardOutlinedIcon />Cupons de Desconto</span>
                                        </a>
                                        <a href={`${route}funcionarios`} className="dropdown-link">
                                            <span className="icons-gap"><BadgeIcon />Funcionários</span>
                                        </a>
                                        <a href={`${route}tabelas-dinamicas`} className="dropdown-link">
                                            <span className="icons-gap"><DashboardCustomizeOutlinedIcon />Tabela Dinâmica</span>
                                        </a>
                                        <a href={`${route}tabela-balcao`} className="dropdown-link">
                                            <span className="icons-gap"><PriceChangeOutlinedIcon />Tabela de Preço Balcão</span>
                                        </a>
                                        <div className='dropdown-link' onClick={togglePagamentosSubMenu}>
                                            <span className="icons-gap"><PaymentsIcon />Pagamentos
                                                <span className={`arrow ${showPagamentosSubMenu ? 'down' : 'right'}`}>
                                                    <ArrowForwardIosIcon style={{ fontSize: '14px', color: 'black' }} />
                                                </span>
                                            </span>
                                        </div>
                                        {showPagamentosSubMenu && (
                                            <Collapse in={showPagamentosSubMenu}>
                                                <div style={{ backgroundColor: '#F7F6F6' }}>
                                                    <a style={{ fontSize: '14px' }} href={`${route}resumo-pagamentos`} className="dropdown-link">Resumo Pagamentos</a>
                                                    <a style={{ fontSize: '14px' }} href={`${route}comissoes`} className='dropdown-link'>Editar Comissões</a>
                                                    <a style={{ fontSize: '14px' }} href={`${route}resumo-comissoes`} className="dropdown-link">Resumo Comissões</a>
                                                </div>
                                            </Collapse>
                                        )}
                                        <div className="dropdown-link" onClick={toggleResponsiblesSubMenu}>
                                            <span className="icons-gap"><CoPresentOutlinedIcon />Responsáveis
                                                <span className={`arrow ${showResponsiblesSubMenu ? 'down' : 'right'}`}>
                                                    <ArrowForwardIosIcon style={{ fontSize: '14px', color: 'black' }} />
                                                </span>
                                            </span>

                                        </div>
                                        {showResponsiblesSubMenu && (
                                            <Collapse in={showResponsiblesSubMenu}>
                                                <div style={{ backgroundColor: '#F7F6F6' }}>
                                                    <a href={`${route}responsaveis`} className="dropdown-link" style={{ fontSize: '14px' }}>Listar Responsáveis</a>
                                                    <a href={`${route}responsaveis/cadastrar`} className="dropdown-link" style={{ fontSize: '14px' }}>Cadastrar Responsável</a>
                                                </div>
                                            </Collapse>
                                        )}
                                        <div className="dropdown-link" onClick={toggleAccreditedSubMenu}>
                                            <span className="icons-gap"><BadgeOutlinedIcon />Credenciados
                                                <span className={`arrow ${showAccreditedSubMenu ? 'down' : 'right'}`}>
                                                    <ArrowForwardIosIcon style={{ fontSize: '14px', color: 'black' }} />
                                                </span>
                                            </span>
                                        </div>
                                        {showAccreditedSubMenu && (
                                            <Collapse in={showAccreditedSubMenu}>
                                                <div style={{ backgroundColor: '#F7F6F6' }}>
                                                    <a href={`${route}credenciados`} className="dropdown-link" style={{ fontSize: '14px' }}>Listar Credenciados</a>
                                                    <a href={`${route}credenciados/cadastrar`} className="dropdown-link" style={{ fontSize: '14px' }}>Cadastrar Credenciado</a>
                                                </div>
                                            </Collapse>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </>
            )}
            {nivelAcesso === NiveisAcesso.PARCEIRO && (
                <>
                    <a href={`${route}pgr`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><HealthAndSafetyIcon />PGR</span>
                        </div>
                    </a>
                    <a href={`${route}pcmso`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><HealingIcon />PCMSO</span>
                        </div>
                    </a>
                    <a href={`${route}empresas`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'><BusinessIcon />Empresas</span>
                        </div>
                    </a>
                    <a href={`${route}funcionarios`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'>
                                <BadgeIcon />Funcionários
                            </span>
                        </div>
                    </a>
                    <a href={`${route}pagamentos`} className="link-wrapper">
                        <div className="link">
                            <span className='icons-gap'>
                                <PaymentsIcon />Pagamentos
                            </span>
                        </div>
                    </a>
                    <a href={`${route}documentos`} className="link-wrapper" style={{ position: 'relative' }} onClick={handleLinkClick}>
                        <div className="link">
                            <span className='icons-gap'>
                                <ArticleIcon />Documentos
                            </span>
                        </div>
                        {notificacaoNaoVisualizadaDocumento > 0 && (
                            <div className='notification-badge-alert' style={{ backgroundColor }}>{notificacaoNaoVisualizadaDocumento}</div>
                        )}
                    </a>
                </>
            )}

            {nivelAcesso === NiveisAcesso.CREDENCIADO && null}
            {nivelAcesso === NiveisAcesso.RESPONSAVEL && (
                <a href={`${route}documentos`} className="link-wrapper" style={{ position: 'relative' }} onClick={handleLinkClick}>
                    <div className="link">
                        <span className='icons-gap'>
                            <ArticleIcon />Documentos
                        </span>
                    </div>
                    {notificacaoNaoVisualizadaDocumento > 0 && (
                        <div className='notification-badge-alert' style={{ backgroundColor }}>{notificacaoNaoVisualizadaDocumento}</div>
                    )}
                </a>
            )}

            {nivelAcesso === NiveisAcesso.TRABALHADOR && (
                <>
                    <a href={`${route}asos-assinados`} className='link-wrapper' style={{ position: 'relative' }} onClick={handleLinkClick}>
                        <div className="link">
                            <span className='icons-gap'><LocalHospitalIcon />ASO</span>
                        </div>

                    </a>
                    <a href={`${route}reaproveitar-asos`} className='link-wrapper' style={{ position: 'relative' }} onClick={handleLinkClick}>
                        <div className="link">
                            <span className='icons-gap'><RestorePageIcon />Reaproveitar Aso</span>
                        </div>
                    </a>
                </>
            )}
            {nivelAcesso === NiveisAcesso.REPRESENTANTE && (
                <a href={`${route}vendas-realizadas`} className='link-wrapper' style={{ position: 'relative' }}>
                    <div className="link">
                        <span className='icons-gap'><PaidIcon />Vendas Realizadas</span>
                    </div>
                </a>
            )}
        </div>
    );
};
